import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_DOCUMENT_TYPES_QUERY = gql`
  query pagedDocumentTypes($pager: PagerInputNew, $filters: DocumentTypesFilterInput) {
    pagedDocumentTypes(pager: $pager, filters: $filters) {
      total
      values {
        ...documentType
      }
    }
  }
  ${Fragments.documentType}
`;
